import styled from 'styled-components';

export const AccessSummary = styled.div`
    display: grid;
    gap: var(--space-2, 8px);
    padding: var(--space-3, 12px) var(--space-4, 16px);
    border-bottom: 1px solid var(--color-border);
    background: color-mix(in srgb, var(--color-muted) 25%, var(--color-card));
`;
export const AccessRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2, 8px);
    min-width: 0;
`;
export const AccessLabel = styled.span`
    margin-right: var(--space-1, 4px);
    color: var(--color-muted-foreground);
    font-size: var(--font-size-xs, 12px);
    font-weight: var(--font-weight-medium, 500);
`;
export const AccessBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    min-width: 0;
    padding: 4px 9px;
    border: 1px solid var(--color-border);
    border-radius: 9999px;
    background: var(--color-card);
    color: var(--color-muted-foreground);
    font-size: var(--font-size-xs, 12px);
    line-height: 1.5;
    overflow-wrap: anywhere;

    svg {
        flex-shrink: 0;
    }

    &[data-enabled='true'] {
        color: var(--color-foreground);
        border-color: color-mix(in srgb, var(--color-primary) 30%, var(--color-border));
        background: color-mix(in srgb, var(--color-primary) 6%, var(--color-card));
    }
`;
export const BadgeKey = styled.span`
    color: var(--color-foreground);
    font-weight: var(--font-weight-semibold, 600);
`;
export const AudienceBadge = styled(AccessBadge)`
    color: var(--color-foreground);
    background: var(--color-muted);
    font-weight: var(--font-weight-medium, 500);
`;
export const AccessRequirement = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 6px;
    color: var(--color-muted-foreground);
    font-size: var(--font-size-xs, 12px);
    line-height: 1.5;

    svg {
        flex-shrink: 0;
        margin-top: 3px;
    }
`;
